export default function printError(err) {
  const reader = new FileReader();
  reader.onload = () => {
    alert(reader.result);
  };
  // Start reading the blob as text.
  reader.readAsText(err.data);
}



// WEBPACK FOOTER //
// ./master/jsx/components/Common/PrintError.jsx